import type { Type } from '@angular/core';

export type ComponentFactoryConfigInputDefinition = {
  /** Converted snake_case key to the actual config key when a legacy handle differs. */
  readonly keyAliases?: Readonly<Record<string, string>>;
};

export const COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS = new Map<
  Type<unknown>,
  ComponentFactoryConfigInputDefinition
>();
